export const common = {
  nav: {
    home: '首頁',
    about: '關於我們',
    services: '服務項目',
    muviSpace: '目靡空間',
    equipment: '器材租賃',
    locations: '門市據點',
    contact: '聯絡我們',
    login: '會員登入',
    account: '會員中心',
    profile: '個人資料',
    orders: '訂單記錄',
    notifications: '通知設定',
    logout: '登出',
    logoutError: '登出失敗，請稍後再試',
    user: '使用者',
    language: '語言切換'
  },
  footer: {
    about: '關於 LensBank',
    aboutDesc: '十多年專業器材租賃經驗，與國內外國際影人們合作多年的信賴品牌',
    quickLinks: '快速連結',
    services: '服務項目',
    contact: '聯絡資訊',
    phone: '電話',
    email: '電子郵件',
    address: '地址',
    followUs: '追蹤我們',
    poweredBy: 'PowerAslan'
  },
  common: {
    learnMore: '了解更多',
    viewDetails: '查看詳情',
    bookNow: '立即預約',
    submit: '送出',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    edit: '編輯',
    delete: '刪除',
    search: '搜尋',
    filter: '篩選',
    reset: '重置',
    loading: '載入中...',
    noData: '暫無資料'
  },
  contact: {
    pageTitle: '聯絡我們',
    pageDesc: '無論是器材租賃、長期合作或專案洽談，歡迎填寫以下表單，我們將盡快與您聯繫',
    formTitle: '洽談合作表單',
    successMessage: '表單已成功送出！我們會盡快與您聯繫。',
    errorMessage: '送出失敗，請稍後再試或直接來電洽詢。',
    companyName: '公司/單位名稱',
    companyNamePlaceholder: '請輸入公司或單位名稱',
    contactName: '聯絡人姓名',
    contactNamePlaceholder: '請輸入聯絡人姓名',
    phone: '聯絡電話',
    phonePlaceholder: '例：0912-345-678',
    email: 'Email',
    emailPlaceholder: 'example@company.com',
    cooperationType: '合作類型（可複選）',
    cooperationTypes: {
      shortTerm: '短期租賃',
      longTerm: '長期租賃',
      production: '拍攝製作',
      crew: '出班協力',
      enterprise: '企業方案',
      education: '教育機構',
      other: '其他'
    },
    budget: '預估預算範圍',
    budgetPlaceholder: '請選擇預算範圍',
    budgetOptions: {
      under10: '10萬以下',
      range1030: '10-30萬',
      range3050: '30-50萬',
      range50100: '50-100萬',
      over100: '100萬以上',
      discuss: '待討論'
    },
    startDate: '預計開始日期',
    rentalDuration: '預計租賃天數',
    rentalDurationPlaceholder: '請選擇',
    rentalDurationOptions: {
      days13: '1-3天',
      days47: '4-7天',
      weeks12: '1-2週',
      weeks24: '2-4週',
      month1plus: '1個月以上',
      longTerm: '長期合作'
    },
    requirements: '需求說明',
    requirementsPlaceholder: '請描述您的需求，例如：需要的器材類型、拍攝用途、特殊需求等...',
    maxChars: '最多 500 字',
    source: '如何得知我們？',
    sourcePlaceholder: '請選擇',
    sourceOptions: {
      search: '網路搜尋',
      social: '社群媒體',
      friend: '朋友推薦',
      reputation: '業界口碑',
      event: '展覽活動',
      other: '其他'
    },
    submitButton: '送出表單',
    submitting: '送出中...',
    contactInfo: '聯絡資訊',
    phoneLabel: '電話',
    emailLabel: 'Email',
    lineLabel: 'LINE 官方帳號',
    businessHours: '營業時間',
    weekdays: '週一至週日',
    hours: '09:00 - 18:00',
    urgentService: '急件服務',
    urgentServiceDesc: '如有緊急需求，歡迎直接來電或透過 LINE 聯繫，我們將優先為您處理。',
    required: '*'
  },
  adminNav: {
    dashboard: '儀表板',
    orders: '訂單管理',
    customers: '客戶管理',
    equipment: '器材管理',
    equipmentList: '器材列表',
    equipmentItems: '品項管理',
    categories: '分類管理',
    brands: '品牌管理',
    accessories: '配件管理',
    locations: '據點管理',
    vehicles: '車輛管理',
    urent: 'Urent 管理',
    urentApplications: '申請列表',
    urentLedger: '交易明細',
    urentContracts: '合約管理',
    prepaid: '儲值客戶',
    prepaidApplications: '申請列表',
    prepaidCustomers: '客戶列表',
    prepaidLedger: '交易明細',
    prepaidPlans: '方案管理',
    analytics: '業績報表',
    attendance: '出勤管理',
    schedules: '排班管理',
    aiAgent: 'AI / Runtime 管理',
    serviceCases: '案例影片管理',
    contracts: '合約管理',
    legalSettings: '甲方資料設定',
    forms: '表單管理',
    cms: 'CMS',
    frontendImages: '前台圖片管理',
    muviSpace: 'MuVi Space｜目靡空間',
    muviBookings: '預約管理',
    muviContent: '內容管理',
    muviSettings: '設定',
    admins: '管理員管理',
    milestones: '里程碑管理',
    settings: '系統設定',
    googleCalendar: 'Google Calendar',
    lineNotify: 'LINE Notify',
    apiSettings: 'API 設定',
    storefrontSort: '前台商品排序設定',
    systemGovernance: '系統治理資訊',
  },
  adminNavGroups: {
    frontendVisual: '前端視覺管理',
    dailyOps: '日常行政',
    productManagement: '產品管理',
    customerManagement: '客戶管理',
    legalContracts: '法務 / 合約',
    accountingReports: '會計 / 報表',
    systemManagement: '系統管理',
  },
  orderGovernance: {
    phasePreContract: '契約前',
    phaseActiveRental: '契約生效中',
    phaseTerminal: '已結案',
    contractActive: '契約生效',
    riskTransferred: '風險已移轉',
    restrictedRollback: '狀態回退受限',
    legalHold: '法務保全',
    earlyPickupApproval: '提前取件核准',
    abnormalFlow: '異常流程',
    overdue: '已逾期',
    disputed: '爭議處理中',
    approvedNotReady: '訂單已接受',
    approvedNotReadyDesc: '訂單已接受，但不代表器材已備妥可取件。可取件需另行明確操作/事件。',
    rentalActiveTitle: '契約生效中，風險已移轉',
    rentalActiveDesc: '器材已交付，租借契約生效，責任及風險已移轉至客戶。',
    cannotOrdinaryCancel: '不可普通取消',
    rollbackNeedsManager: '回退需店長以上核准',
    rollbackAlternative: '如需取消請走歸還 / 爭議 / 協議終止流程',
    canonicalState: '語義狀態',
    legacyStatus: '舊狀態',
    pickupGovernance: '交件治理',
    notificationEvent: '通知事件',
    readyForPickupBlocked: '已阻擋 ready_for_pickup 自動推定',
    pendingBackend: 'Mock / Pending backend',
    needInfoAdminLabel: '需補充資料 / 審核中',
    needInfoCustomerLabel: '需補充資料，請依門市通知處理',
    completedWarning: '歸還/完成流程已執行，但法律保全結案需另行確認',
  },
  aiAgent: {
    pageTitle: 'AI / Runtime 管理中心',
    pageSubtitle: '執行治理 — 通知通道狀態、通知模板、送達紀錄、AI 對話治理',
    tabOverview: '總覽',
    tabProviders: '通知通道',
    tabNotifications: '通知事件',
    tabTemplates: '通知模板',
    tabDeliveries: '送達紀錄',
    tabConversations: '對話紀錄',
    tabAudit: '工具稽核',
    tabPolicies: '治理政策',
    tabDeadLetters: '未送達 / 待處理',
    mockBanner: '模擬資料 — 後端尚未接線',
    sourcePendingBanner: '待後端接線',
    realDataLabel: '已接真實資料',
    mockDataLabel: '模擬資料',
    tokenConfigured: 'Token 已設定',
    tokenNotConfigured: 'Token 未設定',
    environment: '環境',
    lastWebhook: '最後 Webhook',
    lastDelivery: '最後送達',
    deadLetters: '未送達訊息',
    maxCallsPerDay: '每日上限',
    providerStatusSummary: '通知通道狀態摘要',
    runtimeArchitecture: 'Runtime 架構說明',
    notificationRuntime: '通知 Runtime',
    aiConversationRuntime: 'AI 對話 Runtime',
    deliveryLog: '通知送達紀錄',
    deadLetterQueue: '未送達 / 待處理佇列',
    internalOperations: '內部營運',
    customerOrders: '客戶訂單通知',
    previewText: '預覽文字',
    allowedVariables: '可用變數',
    forbiddenNote: '禁止事項',
    safeResponse: '安全回應',
    retryCount: '重試次數',
    eventType: '事件類型',
    terminalReason: '終止原因',
    retryEligible: '可重試',
    safePayload: '安全內容摘要',
    providerCategory: '通知通道',
    deliveryCategory: '送達',
    securityCategory: '安全',
    privacyCategory: '隱私',
    noTokenDisplay: 'Provider token 不在此頁顯示或輸入',
    tokenOnlyInSecret: 'Token 僅存於 Railway / Supabase Secret',
    toolCallAuditLog: '工具呼叫稽核紀錄',
    conversationLog: '對話紀錄',
    statusEnabled: '已啟用',
    statusDisabled: '已停用',
    ruleEnabled: '已啟用',
    ruleDisabled: '已停用',
    deliveryModeDisabled: '已停用',
    deliveryModeFake: 'Fake 模式',
    deliveryModeDryRun: 'Dry-run 模式',
    eventTypeLabel: '事件類型',
    providerPurposeLabel: '通道用途',
    audienceScopeLabel: '對象',
    maxCallsLabel: '每事件上限',
    templateKeyLabel: '模板 key',
    confirmationTitle: '確認變更通知規則',
    confirmationLine1: '此變更僅修改通知規則設定。',
    confirmationLine2: '不會發送 LINE 訊息。',
    confirmationLine3: '不會觸發 live order hook。',
    confirmationLine4: '不會建立通知事件。',
    auditTitle: '通知規則變更紀錄',
    auditAction: '動作',
    auditChangedFields: '變更欄位',
    auditReasonCode: '變更原因',
    auditActorRole: '執行者角色',
    auditTimestamp: '時間',
    noRulesTitle: '尚未建立通知規則',
    noRulesDesc: '可由 owner / super_admin 建立 disabled / fake / dry-run 規則。',
    permissionDeniedRules: '沒有查看通知規則的權限',
    sourcePendingRules: '待後端接線',
    modeMock: '模擬',
    modeDryRun: '演練',
    modeRealStaging: '測試環境',
    modeProduction: '正式環境',
    restrictedView: '僅顯示營運摘要（技術細節已隱藏）',
    adminOnlyTechnical: '技術細節僅限系統治理者檢視',
  },
  analytics: {
    pageTitle: '分析中心',
    pageSubtitle: '來源：admin-analytics-read — 唯讀，不含採購 / 汰換執行功能',
    loading: '讀取分析資料中...',
    empty: '目前沒有符合條件的分析資料',
    scoped: '此角色僅可查看授權範圍內的營運摘要',
    error: '無法讀取分析資料，請稍後再試',
    permissionDenied: '沒有查看此分析資料的權限',
    sourcePending: '待後端接線',
    mockData: '模擬資料',
    suggestionOnly: '僅供建議，不會自動執行',
    humanReviewRequired: '待人工審核',
    notExecutable: '執行功能尚未開放',
    revenueSectionTitle: '營收總覽',
    revenueSectionNote: '操作性收入，非最終會計數字',
    storeSectionTitle: '門市表現',
    productSectionTitle: '品項績效',
    productSectionNote: '品項層級，不代表個別序號器材',
    itemAssetSectionTitle: '器材資產',
    itemAssetSectionNote: '序號已遮罩，不顯示完整序號',
    procurementSectionTitle: '採購候選',
    retirementSectionTitle: '汰換 / 出清候選',
    aiSummarySectionTitle: 'AI 安全摘要資料',
    aiSummarySectionNote: '尚未啟用 AI 分析',
  },
  storefrontSort: {
    pageTitle: '前台商品排序設定',
    pageSubtitle: '設定前台商品列表的預設排序策略與可用排序選項',
    scopeTitle: '影響範圍說明',
    scopeCopy1: '此設定只影響前台商品列表（/equipment、分類頁、品牌頁、搜尋結果），不影響後台產品管理列表的搜尋/篩選/排序邏輯。',
    scopeCopy2: '前台排序套用需另經 storefront integration gate；本頁目前只管理排序策略。',
    strategyCardTitle: '排序策略設定',
    defaultSortMode: '預設排序模式',
    defaultSortModeHint: '預設模式必須在「啟用排序選項」中勾選。',
    enabledSortModes: '啟用排序選項（前台可切換）',
    enabledSortModesHint: '取消勾選會將該選項從前台排序下拉選單中隱藏。預設模式無法取消。',
    featuredFirst: '精選商品優先',
    featuredFirstDesc: '開啟後，標記為「精選」的商品會優先顯示於列表頂端',
    directionControls: '方向控制',
    fixedDirection: '固定',
    auditTitle: '變更紀錄',
    auditEmpty: '變更記錄尚未接後端',
    auditEmptyHint: '後端 audit API 上線後將顯示最近修改記錄',
    saveSettings: '儲存設定',
    saving: '儲存中...',
  }
};
